import {
  hasServings,
  isSubscriptionProduct,
} from 'components/cart/utils/typeInference';
import { PurchaseType } from 'types/product/PurchaseType';
import type { ShopifyProduct } from 'types/product/ShopifyProduct';
import type { Subscription } from 'types/product/Subscription';
import type { Variant } from 'types/product/Variant';

import { getPricePerMonth } from './getPricePerMonth';

export const getSortedItems = (
  updatedProduct: ShopifyProduct,
  selectedVariantGids?: string[],
  purchaseType?: PurchaseType,
) => {
  const variants: Variant[] = selectedVariantGids
    ? updatedProduct.variants.filter((variant) =>
        selectedVariantGids.includes(variant.id),
      )
    : updatedProduct.variants;

  let subscriptions: Subscription[] = [];

  if (isSubscriptionProduct(updatedProduct)) {
    subscriptions = selectedVariantGids
      ? updatedProduct.subscriptions.filter((variant) =>
          selectedVariantGids.includes(variant.id),
        )
      : updatedProduct.subscriptions;
  }

  if (purchaseType === PurchaseType.SUB) {
    return subscriptions.sort(
      (a, b) =>
        (hasServings(a)
          ? getPricePerMonth(a.servings, a.price.amount)
          : a.price.amount) -
        (hasServings(b)
          ? getPricePerMonth(b.servings, b.price.amount)
          : b.price.amount),
    );
  }

  if (purchaseType === PurchaseType.OTP) {
    return variants.sort((a, b) => a.price.amount - b.price.amount);
  }

  return [...variants, ...subscriptions].sort(
    (a, b) =>
      (hasServings(a)
        ? getPricePerMonth(a.servings, a.price.amount)
        : a.price.amount) -
      (hasServings(b)
        ? getPricePerMonth(b.servings, b.price.amount)
        : b.price.amount),
  );
};
